import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import AuthorItem from 'front/components/Common/AuthorItem/AuthorItem';

import {VIEWPORT_EVENTS, WINDOW_BREAKPOINT} from '../../constants/Constants';
import './StoryboardsAuthors.less';

import * as Template from './StoryboardsAuthors.jinja';

const Selectors = {
    el: '.StoryboardsAuthors',
    wrapper: '.StoryboardsAuthors-wrapper.mob',
    authorItems: '.AuthorItem',
    topBarFilters: '.TopBar-filters',
    tobBarFilterItem: '.TopBar-filtersItem'
};

const BindFunctions = [
    'onResize',
    'onItemClick',
    'unique'
];


export default class StoryboardsAuthors extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.tobBarFilterItem}`]: this.onItemClick
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {
            'top-bar': {selector: '.TopBar', viewConstructor: TopBar},
            'author-item': {selector: '.AuthorItem', viewConstructor: AuthorItem}
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.$wrapper = this.$(Selectors.wrapper);
        this.arr = [];

        this.onResize();
        $(window).on(VIEWPORT_EVENTS.resize, this.onResize);

        this.$(Selectors.tobBarFilterItem).eq(0)
            .addClass('active');
    }

    unique(arr) {
        let result = [];
        for (let str of arr) {
            if (!result.includes(this.$(str).data('name'))) {
                result.push(this.$(str).data('name'));
                this.$(str).addClass('show');
            }
        }

        this.$(Selectors.authorItems).map((i, item) => {
            const id = $(item).data('id');

            this.$('.StoryboardsAuthors-left.show').map((it, el) => {
                if (id === $(el).data('id')) {
                    $(item).addClass('show');
                }
            });
        });
    }

    onResize() {
        let ww = window.innerWidth;
        if (WINDOW_BREAKPOINT.widthBreakpoint >= ww) {
            this.arr = [...this.$wrapper.children('div')];
            this.unique(this.arr);
        }
    }

    onItemClick(e) {
        const $target = $(e.currentTarget);

        if ($target.hasClass('active')) {
            e.preventDefault();
            window.location = Urls['front:storyboards']();
        }
    }
}
